// src/socket/handleScreenShare.ts
import Payload from "../interfaces/Payload";

export const handleScreenShare = (payload: Payload) => {
  if (payload.type !== 'SHARE_SCREEN') return null;

  switch (payload.sub_type) {
    case 'REQUEST_FOR_SHARE_SCREEN':
      console.log('Screen share request received:', payload);
      return { type: 'REQUEST_FOR_SHARE_SCREEN', payload };

    case 'RESPONSE_TO_SCREEN_SHARE':
      if (payload.action === 'trainer_approved') {
        return { type: 'RESPONSE_TO_SCREEN_SHARE', screenShareStatus: 'approved' };
      } else if (payload.action === 'trainer_rejected') {
        return { type: 'RESPONSE_TO_SCREEN_SHARE', screenShareStatus: 'rejected' };
      }
      break;

    case 'SHARE_TRAINEE_DETAILS':
      if (payload.action === 'stop') {
        return { type: 'SHARE_TRAINEE_DETAILS', isScreenPresented: false, screenShareStatus: 'idle' };
      }
      break;

    default:
      console.log('Unknown screen share sub_type:', payload.sub_type);
      return null;
  }

  return null;
};